import React, { useState, useEffect } from "react";
import { Card, Image, Spin } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { URL_BASE } from "../../../../constants/url";

export default function ThumbnailFoto({ foto }) {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchFoto = async () => {
      try {
        setLoading(true);
        const url = `${URL_BASE}/api/FotosAsistencia/GetFotosPorAsistencia/${foto.id}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (!response.ok) {
          throw new Error("Error al cargar la imagen");
        }

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);
        setError(false);
      } catch (err) {
        console.error("Error fetching foto:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (foto && foto.id !== undefined) {
      fetchFoto();
    }

    // Cleanup function para liberar la URL del objeto
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [foto]);

  if (loading) {
    return (
      <Card className="foto-card-loading">
        <Spin size="large" />
      </Card>
    );
  }

  if (error) {
    return (
      <Card className="foto-card-error">
        <div className="foto-card-error-text">Error al cargar la imagen</div>
      </Card>
    );
  }

  return (
    <Card hoverable className="foto-card" bodyStyle={{ padding: 0 }} cover={
        <Image
          alt={foto.nombre || "Foto de servicio"}
          src={imageUrl}
          className="foto-image"
          preview={{
            mask: (
              <div
                className="foto-preview-mask"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
                onClick={(e) => {
                  e.currentTarget.style.transform = "scale(0.9)";
                  setTimeout(() => {
                    e.currentTarget.style.transform = "scale(1)";
                  }, 150);
                }}
              >
                <EyeOutlined /> Ver imagen
              </div>
            ),
          }}
        />
      }
    >
    </Card>
  );
}